exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#title-view {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  background: #039be5;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center; }\n\n#title-view h1 {\n  color: #fff;\n  margin-top: 10px;\n  margin-bottom: 10px; }\n\n.close-button {\n  left: 34%;\n  top: 1px; }\n\n.form {\n  padding: 31px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /vercel/path0/src/app/main/content/apps/e-commerce/orders/order-list/order-edit/order-edit.component.scss
// module id = ../../../../../src/app/main/content/apps/e-commerce/orders/order-list/order-edit/order-edit.component.scss
// module chunks = main